import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ModalActividadesTrabajadorPageRoutingModule } from './modal-actividades-trabajador-routing.module';

import { ModalActividadesTrabajadorPage } from './modal-actividades-trabajador.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ModalActividadesTrabajadorPageRoutingModule
  ],
  declarations: [ModalActividadesTrabajadorPage]
})
export class ModalActividadesTrabajadorPageModule {}
